import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'primereact/resources/themes/lara-light-teal/theme.css'; //theme css
import 'primereact/resources/primereact.min.css'; // core css
import { Provider } from 'react-redux';
import { ProSidebarProvider } from 'react-pro-sidebar';
import store from './store';
import 'primeicons/primeicons.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const baseURL = window.location.pathname
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter basename={baseURL}>
      <ProSidebarProvider>
        <App />
      </ProSidebarProvider>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
